import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, keywords, path }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`https://digitalshifts.net${path}`} />
    </Helmet>
  );
};

export default SEO;
